export const appendActions = (data, action) => {
  return data.map((nestedArray) => [...nestedArray, action]);
};

export const traderTransformData = (data) => {
  return data.map((obj) => [
    obj.projectName,
    obj.projectId,
    obj.number_Of_Credits,
    obj.token_type,
    obj.registry_name,
    obj.bidAmount,
  ]);
};

export const sellerTransformData = (data) => {
  return data.map((obj) => [
    obj.projectName,
    obj.projectId,
    obj.noOfCredits,
    obj.tokenType,
    obj.registry,
    obj.listedPrice,
  ]);
};

export const buyerTransformData = (data) => {
  return data.map((obj) => [
    obj.projectName,
    obj.projectId,
    obj.noOfCredits,
    obj.tokenType,
    obj.registry_name,
    obj.listedPrice,
    // obj.bid_Id,
  ]);
};

export const transformData = (data, userType, obj) => {
  if (userType === "seller") {
    return sellerTransformData(data, obj);
  } else if (userType === "buyer") {
    return buyerTransformData(data);
  } else {
    return traderTransformData(data);
  }
};

export const getHeaderData = (userType, selectedButton) => {
  if (userType === "seller") {
    if (selectedButton === "BidReceived") {
      return [
        "Project Name",
        "Project ID",
        "No. of credits",
        "Token Type",
        "Registry",
        "Listed Price",
        "Action",
      ];
    }
    if (selectedButton === "CancelledBid") {
      return [
        "Bid Id",
        "Project Name",
        "Project Id",
        "No. of credits",
        "Token Type",
        "Registry",
        "Closed Price",
        "Action",
      ];
    }
    if (selectedButton === "CompletedBid") {
      return [
        "Transaction ID",
        "Bid ID",
        "Project Name",
        "Project ID",
        "No. of credits",
        "Token Type",
        "Listed/Bid Price",
        "Status",
        "Action",
      ];
    }
  } else if (userType === "buyer") {
    if (selectedButton === "BidPlaced" || selectedButton === "CancelledBid") {
      return [
        "Bid Id",
        "Project Name",
        "Project ID",
        "No. of credits",
        "Token Type",
        "Registry",
        "Bid Price",
        "Action",
      ];
    }
    if (selectedButton === "CompletedBid") {
      return [
        "Transaction ID",
        "Bid ID",
        "Project Name",
        "Project ID",
        "No. of credits",
        "Token Type",
        "Listed/Bid Price",
        "Status",
        "Action",
      ];
    }
  } else {
    if (selectedButton === "BidPlaced") {
      return [
        "Bid Id",
        "Project Name",
        "Project ID",
        "No. of credits",
        "Token Type",
        "Registry",
        "Bid Price",
        "Action",
      ];
    }
    if (selectedButton === "CancelledBid") {
      return [
        "Bid Id",
        "Project Name",
        "Project ID",
        "No. of credits",
        "Token Type",
        "Registry",
        "Bid Type",
        "Listed/Bid Price",
        "Action",
      ];
    }
    if (selectedButton === "CompletedBid") {
      return [
        "Transaction ID",
        "Bid ID",
        "Project Name",
        "Project ID",
        "No. of credits",
        "Token Type",
        "Bid Type",
        "Listed/Bid Price",
        "Status",
        "Action",
      ];
    }
    if (selectedButton === "BidReceived") {
      return [
        "Project Name",
        "Project ID",
        "No. of credits",
        "Token Type",
        "Registry",
        "Listed Price",
        "Action",
      ];
    }
  }
};
